import React from 'react';
import './Committee.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

const Committee = () => {
  const { t } = useLanguage();
  const committeeMembers = t('committee.members', { returnObjects: true }) || [];

  return (
    <div className="committee-page">
      <div className="container">
        <section className="committee-section">
          <div className="trust-intro">
            <h2 className="title-marathi">{t('committee.pageTitle')}</h2>
            <div className="subtitle-frame">
              <span className="line-dec"></span>
              <span className="trust-label">{t('committee.pageSubtitle')}</span>
              <span className="line-dec"></span>
            </div>
          </div>

          <p className="committee-intro-text">
            {t('committee.intro')}
          </p>

          <div className="committee-table-container">
            <table className="committee-table">
              <thead>
                <tr>
                  <th>{t('committee.table.name')}</th>
                  <th>{t('committee.table.role')}</th>
                </tr>
              </thead>
              <tbody>
                {committeeMembers.map((member) => (
                  <tr key={member.id}>
                    <td>{member.name}</td>
                    <td>{member.role}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Trust Information Card */}
        <section className="trust-info-section">
          <div className="trust-info-card">
            <div className="trust-info-header">
              <div className="trust-emblem">
                <Icon name="temple" />
              </div>
              <div className="trust-header-text">
                <h2 className="trust-info-title">{t('committee.trust.sectionTitle')}</h2>
                <div className="trust-name-block">
                  <p className="trust-marathi-name">{t('committee.trust.trustNameMarathi')}</p>
                  <p className="trust-english-name">{t('committee.trust.trustName')}</p>
                </div>
              </div>
            </div>

            <div className="trust-divider" />

            <div className="trust-details-grid">
              <div className="trust-detail-item highlight">
                <Icon name="certificate" />
                <span>{t('committee.trust.registerNumber')}</span>
              </div>
              <div className="trust-detail-item">
                <Icon name="info" />
                <span>{t('committee.trust.trustType')}</span>
              </div>
              <div className="trust-detail-item">
                <Icon name="calendar" />
                <span>{t('committee.trust.established')}</span>
              </div>
              <div className="trust-detail-item">
                <Icon name="location" />
                <span>{t('committee.trust.jurisdiction')}</span>
              </div>
            </div>

            <div className="trust-divider" />

            <div className="trust-objectives">
              <h3 className="objectives-title">
                <Icon name="flag" /> {t('committee.trust.sectionTitle') === 'About the Trust' ? 'Objectives' : 'उद्दिष्टे'}
              </h3>
              <ul className="objectives-list">
                <li><Icon name="check" />{t('committee.trust.objective1')}</li>
                <li><Icon name="check" />{t('committee.trust.objective2')}</li>
                <li><Icon name="check" />{t('committee.trust.objective3')}</li>
                <li><Icon name="check" />{t('committee.trust.objective4')}</li>
              </ul>
            </div>

            <div className="trust-footer-note">
              <Icon name="info" />
              <p>{t('committee.trust.footerNote')}</p>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Committee;

